









































import Vue from 'vue'


export default Vue.extend({
  name: 'BaseSelect',
  // Disable automatic attribute inheritance, so that $attrs are
  // passed to the <input>, even if it's not the root element.
  // https://vuejs.org/v2/guide/components-props.html#Disabling-Attribute-Inheritance
  inheritAttrs: false,
  // Change the v-model event name to `update` to avoid changing
  // the behavior of the native `input` event.
  // https://vuejs.org/v2/guide/components-custom-events.html#Customizing-Component-v-model
  model: {
    event: 'update',
  },
  props: {
    value: {
      type: [String, Number]
    },
    isVertical: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    }
  }
})
